import { useTheme as useMUITheme } from '@mui/material';

export const useTheme = useMUITheme;
